import {DadosUsuarioService} from 'src/app/services/dados-usuario.service';
import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FazerPedidoService} from 'src/app/services/fazer-pedido.service';
import {finalize, map, switchMap, take} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {UsuarioBeneficioService} from 'src/app/services/usuario-beneficio.service';
import {PedidoAvulsoFormInterface} from '@interfaces/pedido-avulso';
import {SummaryRequest} from '@interfaces/summary-request';
import {FazerPedidoAvulsoService} from '@services/fazer-pedido-avulso.service';
import {ModalLoadingComponent} from 'src/app/components/modal-loading/modal-loading.component';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {PedidoFormBase} from '../shared/pedido-form/pedido-form.base';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { AlertConfirmarPedidoComponent } from '../../components/alert-confirmar-pedido/alert-confirmar-pedido.component';
import { AlertSucessoComponent } from '../../components/alert-sucesso/alert-sucesso.component';
import { AlertErroCustomizadoComponent } from '../../components/alert-erro-customizado/alert-erro-customizado.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { FormsModule } from '@angular/forms';
import { ClickedOutsideDirective } from '../../directives/clicked-outside.directive';
import { SelectComponent } from '../../components/select/select.component';
import { NgClass, CurrencyPipe } from '@angular/common';
import { FieldErrorComponent } from '../../components/field-error/field-error.component';
import { PedidoFormFieldsComponent } from '../shared/pedido-form/pedido-form-fields.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CpfPipe } from '../../pipes/cpf.pipe';
import { FilterPipe } from '../../pipes/filter.pipe';

@Component({
    selector: 'app-fazer-pedido-avulso',
    templateUrl: './fazer-pedido-avulso.component.html',
    styleUrls: ['./fazer-pedido-avulso.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, HeaderComponent, BotaoChatComponent, AlertConfirmarPedidoComponent, AlertSucessoComponent, AlertErroCustomizadoComponent, BreadcrumbComponent, FormsModule, ClickedOutsideDirective, SelectComponent, NgClass, FieldErrorComponent, PedidoFormFieldsComponent, FooterComponent, CurrencyPipe, CpfPipe, FilterPipe]
})
export class FazerPedidoAvulsoComponent extends PedidoFormBase implements OnInit {

  public readonly UNPROCESSABLE_ENTITY_CODE = 422;

  public idEmpresa: any;
  public formData = new FormData();
  public enderecoFaturamento: any = '';
  public allEnderecos: any;
  public ignorarInconsistencias = false;
  public existemErros: any = false;
  public qtdeEnderecosListBox: number;

  public loadingGenerico = false;

  public enderecoFaturamentoError = false;
  public enderecoFaturamentoMessageError = 'Endereço de faturamento Inválido';

  public showAlertErro = false;
  public mensagemErroApi: string;

  public isErrorFazerPedido = false;

  public paginacao: any = 0;
  public tamanhoPagina: any = 10000;
  public status = 'S';
  public listaUsuarios: Array<string> = [];

  public filtro: any;
  public searchTextFilter: any;
  public searchTextFilterUsers = false;
  public idSalvo: any;
  public usuarioSalvo: Array<any> = [];
  public usuarioSemBeneficio: Array<any> = [];
  public valoresSalvos: any;
  public idUsuario: any;
  public enderecoSalvo: any;
  public enderecoSalvoOptions: any;

  public procuraUsuario: any;
  public procuraUsuario2: any;
  public idMongo: any;
  dialogRef: MatDialogRef<ModalLoadingComponent>;
  public alertSucesso: any;
  public alertSucessoMensagem: any = 'Calculos realizados com sucesso';
  public alertSucessoSubtitulo: any = '';

  public showUsuariosRemovidos = false;
  public descricaoUsuariosRemovidos = 'Alguns usuários selecionados não possuem benefícios ativos e foram removidos da solicitação.';

  mensagemErroApiTitulo: string;
  mensagemErroApiBotao: string;
  searchTextFilterFormatted: any;
  dadosUltimoPedido: any;
  usuarios: any[] = [];
  usuarioSelecionado: any;
  calculado = false;
  buscandoEnderecos = false;
  public showTentarNovamente: boolean = false;
  public descricaoTentarNovamente: string = 'Ocorreu um erro ao realizar os cálculos do pedido';

  private pedidoBody = {} as PedidoAvulsoFormInterface;
  public bodyRequest: SummaryRequest[] = [];
  public nenhumUsuarioComBenficioAtivo: boolean = false;

  constructor(protected readonly fazerPedidoService: FazerPedidoService,
              private readonly router: Router,
              private readonly usuarioBeneficioService: UsuarioBeneficioService,
              private readonly dadosUsuarioService: DadosUsuarioService,
              private readonly activatedRoute: ActivatedRoute,
              private readonly fazerPedidoAvulsoService: FazerPedidoAvulsoService,
              private readonly dialog: MatDialog,
  ) {
    super(fazerPedidoService);
    const nav = this.router.currentNavigation();
    const usuariosPedidoAvulso: Array<any> = nav?.extras.state?.users;
    this.usuarioSalvo = usuariosPedidoAvulso.map((u) => ({idUsuario: u.idUsuario, matricula: u.codigoUsuario, nome: u.nomeUsuario, cpf: u.codigoCpf, departamento: u.descDepartamento}));
    this.listaUsuarios = usuariosPedidoAvulso.map(u => u.idUsuario);
  }

  ngOnInit(): void {
    this.idEmpresa = this.getIdEmpresaLocalStorage();
    this.prePago = !localStorage.getItem('tipoPagamentoEmpresa').includes('PÓS-PAGO - BOLETO COM REGISTRATION');
    this.init();
    this.getEnderecoFaturamento();
    this.getInfoUltimoPedido();
    this.calcularPedido(true);
  }

  private init() {
    this.ordemEnvelopes = 'N';
    this.bodyRequest = [];
    this.getAllContatos();
  }

  private getAllContatos() {
    this.loadingGenerico = true;
    this.fazerPedidoService.getAllContatos(this.idEmpresa)
      .pipe(take(1)).subscribe({
        next: (resposta: any) => {
          this.contatos = resposta.response;
          this.loadingGenerico = false;
        },
        error: () => { this.loadingGenerico = false; }
      });
  }

  onEnderecoSelecionado(value) {
    this.enderecoFaturamento = value;
    this.enderecoFaturamentoError = this.enderecoFaturamento.length === 0;
  }

  onSubmit(evento: any) {
    if (evento) {
      this.createPedidoBody();
      if (this.isErrorFields === false) {
        this.loadingGenerico = true;
        this.fazerPedidoService.createPedidoIntegralPost(this.pedidoBody, this.idEmpresa, this.idMongo)
          .pipe(take(1))
          .subscribe({
            next: () => {
              this.loadingGenerico = false;
              this.router.navigate(['resumo-pedido']);
            },
            error: () => {
              this.loadingGenerico = false;
              this.showAlertErro = true;
              this.mensagemErroApi = 'Favor tentar novamente.';
            }
          });
      } else {
        this.pedidoBody = {} as PedidoAvulsoFormInterface;
      }
    }
  }

  eventoAlertErro(evento: any) {
    if (this.nenhumUsuarioComBenficioAtivo) {
      this.router.navigate(['/usuario-beneficio']);
    }
    this.showAlertErro = false;
  }

  getAllUsuarios() {
    this.usuarioBeneficioService.getAllUsuarios(this.idEmpresa, this.paginacao, this.tamanhoPagina, this.status, '')
      .pipe(take(1)).subscribe({
        next: (resposta: any) => {
          const idsRemover = new Set(this.usuarioSalvo.map(u => u.idUsuario));
          this.usuarios = resposta.response.data.filter(u => !idsRemover.has(u.idUsuario));
        },
        error: (error) => {
          console.error(error);
          this.usuarios = [];
        }
      });
  }

  closeSearchTextFilter(user) {
    this.searchTextFilter = user.nomeUsuario;
    this.idSalvo = user.idUsuario.toString();
    this.usuarioSelecionado = user;
    this.searchTextFilterFormatted = '';
  }

  formatSearchText() {
    if (this.searchTextFilter !== '') {
      const regex = /[.,/-]/g;
      this.searchTextFilterFormatted = this.searchTextFilter.replace(regex, '');
    }
  }

  openFilter() {
    this.getAllUsuarios();
    this.searchTextFilterUsers = true;
  }

  closeSearchText(event: Event) {
    this.searchTextFilterUsers = false;
  }

  addUsers() {
    this.calculado = false;
    if (this.usuarioSelecionado === undefined) {
      this.mensagemErroApi = 'Favor selecionar um usuário';
      this.mensagemErroApiBotao = 'FECHAR';
      this.mensagemErroApiTitulo = 'Usuário não selecionado';
      this.abriAlertErro();
    } else if (this.listaUsuarios.includes(this.usuarioSelecionado.idUsuario)) {
      this.mensagemErroApi = 'Usuário já selecionado.';
      this.mensagemErroApiBotao = 'FECHAR';
      this.mensagemErroApiTitulo = 'Erro ao adicionar usuário';
      this.abriAlertErro();
      this.searchTextFilter = '';
      this.searchTextFilterFormatted = '';
      this.idSalvo = undefined;
      this.usuarioSelecionado = undefined;
    } else {
      const usuarioAdicionado = {
        idUsuario: this.usuarioSelecionado.idUsuario,
        matricula: this.usuarioSelecionado.codigoUsuario,
        nome: this.usuarioSelecionado.nomeUsuario,
        cpf: this.usuarioSelecionado.codigoCpf,
        departamento: this.usuarioSelecionado.descDepartamento
      };
      if (!this.listaUsuarios.includes(this.usuarioSelecionado.idUsuario)) {
        this.usuarioSalvo.push(usuarioAdicionado);
        this.listaUsuarios.push(this.usuarioSelecionado.idUsuario);
        this.searchTextFilter = '';
        this.searchTextFilterFormatted = '';
        this.idSalvo = undefined;
        this.usuarioSelecionado = undefined;
      }
      this.valoresSalvos = undefined;
      this.calculado = false;
    }
  }

  getEnderecoFaturamento() {
    this.buscandoEnderecos = true;
    this.dadosUsuarioService.getAllEnderecosFaturamento(this.idEmpresa)
      .pipe(take(1))
      .subscribe({
        next: (resposta: any) => {
          this.buscandoEnderecos = false;
          this.enderecoSalvo = resposta.response;
          this.enderecoSalvoOptions = this.enderecoSalvo.map((endereco) => ({
            value: endereco.idEndereco,
            description: `${endereco.descricaoLogradouro}, ${endereco.codigoNumero} - ${endereco.codigoBairro} - ${endereco.codigoCidade} - ${endereco.codigoEstado} - ${endereco.codigoCep}`
          }));
        },
        error: (error) => {
          console.error(error);
          this.buscandoEnderecos = false;
        }
      });
  }

  clickExclude(usuario) {
    if (this.idUsuario === usuario.idUsuario.toString()) {
      this.mensagemErroApi = 'Não é possível excluir o usuário primário.';
      this.mensagemErroApiBotao = 'FECHAR';
      this.mensagemErroApiTitulo = 'Erro ao excluir usuário';
      this.abriAlertErro();
    } else if (this.usuarioSalvo.includes(usuario)) {
      this.procuraUsuario = this.usuarioSalvo.findIndex(x => x.idUsuario === usuario.idUsuario);
      this.usuarioSalvo.splice(this.procuraUsuario, 1);
      this.procuraUsuario = this.listaUsuarios.indexOf(usuario.idUsuario.toString());
      this.listaUsuarios.splice(this.procuraUsuario, 1);
      this.calculado = false;
      this.valoresSalvos = undefined;
    } else {
      alert('erro');
    }
  }

  public eventoAlertErroFechou(event: any) {
    this.showAlertErro = event;
  }

  public abriAlertErro() {
    this.showAlertErro = true;
  }

  goBackPage() { this.usuarioBeneficioService.cleanSelectedUsers(); window.history.back(); }

  getInfoUltimoPedido() {
    this.fazerPedidoService.getInfoUltimoPedidoEmpresa(this.idEmpresa)
      .pipe(take(1)).subscribe({
        next: (response: any) => {
          this.dadosUltimoPedido = response.response;
          this.emailConfirmacao = this.dadosUltimoPedido.emailContato;
          this.emailNfe1 = this.dadosUltimoPedido.emailNf1;
          this.emailNfe2 = this.dadosUltimoPedido.emailNf2;
          this.contatoSelecionado = this.dadosUltimoPedido.idContatoResponsavel;
          const ordemEnvelopes = this.dadosUltimoPedido.ordemEnvelopes;
          this.ordemEnvelopes = (ordemEnvelopes === '' || ordemEnvelopes === null) ? 'N' : ordemEnvelopes;
          this.enderecoFaturamento = this.dadosUltimoPedido.idEnderecoFaturamento;
        },
        error: (error: any) => { console.error(error); }
      });
  }

  createFormData() {
    this.isErrorFields = false;
    this.appendContato();
    this.appendEnderecoFaturamento();
    this.appendDataPagamento();
    this.appendDatas();
    this.appendEnvelopes();
    this.appendEmails();
    this.formData.append('idImportacao', this.idMongo);
    this.formData.append('idEmpresaPai', this.getIdEmpresaLocalStorage());
    this.formData.append('idUsuario', this.listaUsuarios.toString());
  }

  private appendContato(): void {
    if (this.contatoSelecionado) {
      this.formData.append('contato', this.contatoSelecionado);
    } else {
      this.contatoSelecionadoError = true;
      this.isErrorFields = true;
    }
  }

  private appendEnderecoFaturamento(): void {
    if (this.enderecoFaturamento) {
      this.formData.append('endFat', this.enderecoFaturamento);
    } else {
      this.enderecoFaturamentoError = true;
      this.isErrorFields = true;
    }
  }

  private appendDataPagamento(): void {
    if (!this.prePago) { return; }
    if (this.dataPagamento) {
      this.formData.append('dtPgto', this.dataPagamento.toISOString());
    } else {
      this.dataPagamentoError = true;
      this.dataPagamentoMessageError = 'Selecione uma data de pagamento!';
      this.isErrorFields = true;
    }
  }

  private appendDatas(): void {
    if (this.dataInicialPedido) {
      this.formData.append('dtIni', this.dataInicialPedido.toISOString());
    } else {
      this.dataInicialError = true;
      this.isErrorFields = true;
    }
    if (this.dataFinalPedido) {
      this.formData.append('dtFim', this.dataFinalPedido.toISOString());
    } else {
      this.dataFinalError = true;
      this.isErrorFields = true;
    }
  }

  private appendEnvelopes(): void {
    if (this.ordemEnvelopes) {
      this.formData.append('envelopes', this.ordemEnvelopes);
    } else {
      this.departamentoError = true;
      this.isErrorFields = true;
    }
  }

  private appendEmails(): void {
    if (this.emailConfirmacao) {
      this.formData.append('emailConf', this.emailConfirmacao);
    } else {
      this.emailValidacaoError = true;
      this.isErrorFields = true;
    }
    if (this.emailNfe1) {
      this.formData.append('emailNfe1', this.emailNfe1);
    } else {
      this.emailNfe1Error = true;
      this.isErrorFields = true;
    }
    if (this.emailNfe2) {
      this.formData.append('emailNfe2', this.emailNfe2);
    } else {
      this.emailNfe2Error = true;
      this.isErrorFields = true;
    }
  }

  private createPedidoBody() {
    const pedidoAvulsoForm = {} as PedidoAvulsoFormInterface;
    this.isErrorFields = false;

    this.validarContato(pedidoAvulsoForm);
    this.validarDataPagamento(pedidoAvulsoForm);
    this.validarDataInicial(pedidoAvulsoForm);
    this.validarDataFinal(pedidoAvulsoForm);
    this.validarEnvelopes(pedidoAvulsoForm);
    this.validarEmails(pedidoAvulsoForm);
    this.validarEnderecoFaturamento(pedidoAvulsoForm);

    this.bodyRequest.push({idEmpresa: this.idEmpresa, idPedidoAtivo: this.idMongo});
    pedidoAvulsoForm.dadosEmpresasPedidos = this.bodyRequest;
    pedidoAvulsoForm.idPedidoAtivo = this.idMongo;
    pedidoAvulsoForm.msgEnv = 'avulso';
    pedidoAvulsoForm.numCel = '';
    this.pedidoBody = pedidoAvulsoForm;
  }

  private validarEnderecoFaturamento(pedidoAvulsoForm: PedidoAvulsoFormInterface): void {
    if (this.enderecoFaturamento) {
      pedidoAvulsoForm.ddd = this.enderecoFaturamento;
    } else {
      this.enderecoFaturamentoError = true;
      this.isErrorFields = true;
    }
  }

  public calcularPedido(exibirLoading: boolean): void {
    this.showTentarNovamente = false;
    if (exibirLoading) {
      this.loadingGenerico = false;
      this.openLoading('Pedido Avulso sendo calculado',
        'Os dados dos cálculos do pedido avulso estarão prontos em alguns <span style="font-weight: 600;">segundos.</span>',
        '<span style="font-weight: 600;">Aguarde o cálculo do pedido avulso.', '633px', true, false, ''
      );
    }

    this.fazerPedidoAvulsoService.iniciarCalculos(this.idEmpresa, this.listaUsuarios)
      .pipe(
        switchMap(activeOrderId =>
          this.fazerPedidoAvulsoService.verificarDadosCalculados(this.idEmpresa, activeOrderId)
        ),
        finalize(() => this.closeLoading()),
        map(body => {
          if (body.temErro === true) { throw new Error('Usuários com erro'); }
          return body;
        }),
      ).subscribe({
        next: (body) => {
          this.preencherValorBeneficio(body);
          this.valoresSalvos = body.order;
          this.idMongo = body.activeOrderId;
          if (this.usuarioSemBeneficio.length > 0) {
            this.showUsuariosRemovidos = true;
          } else {
            this.abrirAlertSucesso();
          }
          this.calculado = true;
        },
        error: err => { this.tratarErroCalculoPedidoAvulso(err); }
      });
  }

  private preencherValorBeneficio(body) {
    const usuariosCalculados = body.order.usuarios;
    const calculoMap = new Map(usuariosCalculados.map(u => [u.idUsuario, u.valorBeneficio]));
    this.usuarioSemBeneficio = this.usuarioSalvo.filter(u => !calculoMap.has(u.idUsuario)).map(u => u.nome);
    this.usuarioSalvo = this.usuarioSalvo.filter(u => calculoMap.has(u.idUsuario));
    this.usuarioSalvo.forEach((usuario) => {
      if (calculoMap.has(usuario.idUsuario)) {
        usuario.valorBeneficio = calculoMap.get(usuario.idUsuario);
      }
    });
  }

  private tratarErroCalculoPedidoAvulso(err): void {
    let abrirErro = true;
    this.showTentarNovamente = false;
    this.mensagemErroApi = 'Ocorreu um erro ao calcular as taxas do pedido avulso';
    this.mensagemErroApiBotao = 'FECHAR';
    this.mensagemErroApiTitulo = 'Erro ao calcular as Taxas';

    if (err?.status >= 500 && err?.status < 600) {
      abrirErro = false;
      this.showTentarNovamente = true;
      this.descricaoTentarNovamente = 'Serviço de cálculo temporariamente indisponível';
    }
    if (err?.status === this.UNPROCESSABLE_ENTITY_CODE) {
      this.mensagemErroApiTitulo = 'Não foi possível concluir a solicitação.';
      this.mensagemErroApi = 'Este usuário não possui benefícios ativos no momento.';
      this.nenhumUsuarioComBenficioAtivo = true;
    }
    if (abrirErro) { this.abriAlertErro(); }
  }

  public fecharTentarNovamente(): void {
    this.showTentarNovamente = false;
    this.router.navigate(['/usuario-beneficio']);
  }

  public eventoAlertSucessoFechou(event: any) {
    this.alertSucesso = event;
  }

  public abrirAlertSucesso() {
    this.alertSucesso = true;
  }

  closeLoading() {
    if (this.dialogRef) { this.dialogRef.close(); }
  }

  openLoading(title: string, text1: string, text2: string, width: string, disableClose: boolean, erroLoading: boolean, textButton: string) {
    this.closeLoading();
    this.dialogRef = this.dialog.open(ModalLoadingComponent, {
      disableClose,
      hasBackdrop: true,
      data: {erroLoading, title, text1, text2, textButton},
      width
    });
  }

  fechaUsuariosRemovidos(): void {
    this.showUsuariosRemovidos = false;
  }
}
